import LoginForm from './components/LoginForm'
import RegisterForm from './components/RegisterForm'
import RegisterSuccess from './components/RegisterSuccess'
import ResetPasswordForm from './components/ResetPasswordForm'

export const REQUIRED_ERROR_MESSAGE = 'Bitte füllen Sie dieses Feld aus!'
export const EMAIL_FORMAT_ERROR_MESSAGE = 'Bitte geben Sie eine gültige Adresse ein!'

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const FORM_TYPES = {
  login: {
    formTag: LoginForm,
    title: 'Login'
  },
  register: {
    formTag: RegisterForm,
    title: 'Registrieren'
  },
  registerSuccess: {
    formTag: RegisterSuccess,
    title: 'Registrierung erfolgreich – Bitte aktivieren Sie Ihren Account'
  },
  reset: {
    formTag: ResetPasswordForm,
    title: 'Passwort vergessen'
  }
}

export const TERMS = {
  termsOfUse: {
    title: 'Nutzungsbedingungen',
    href: '/nutzungsbedingungen'
  },
  privacyPolicy: {
    title: 'Datenschutzbestimmungen',
    href: '/datenschutz'
  }
}
